import { Icon } from "@/components/general/icon/Icon";
import { EIcon } from "@/utils/enums";
import { Button, type ButtonVariant } from "@pepperstone/pepper-ui-kit";
import { EBrand } from "@repo/ui";

type TBrandedButtonProps = {
  brand?: string;
  amount?: number;
  currencySymbol?: string;
  children: React.ReactNode;
  next?: () => void;
  disabled?: boolean;
};

export const BrandedButton = ({
  brand,
  children,
  next,
  disabled = false,
}: TBrandedButtonProps) => {
  let variant: ButtonVariant | "ps-btn-primary" | "ps-btn-secondary" =
    "ps-btn-primary";

  switch (brand) {
    case "paypal": {
      variant = "ps-btn-blue-primary";
      break;
    }
    default: {
      variant = "ps-btn-primary" as const;
    }
  }

  return (
    <Button
      type="button"
      variant={variant}
      onClick={next || (() => {})}
      disabled={disabled}
    >
      {brand === EBrand.ApplePay && (
        <>
          {children}
          <Icon name={EIcon.ApplePay} />
          Pay
        </>
      )}
      {brand === EBrand.PayPal && (
        <>
          <Icon name={EIcon.PayPal} />
          <span>{children}</span>
        </>
      )}
      {brand === EBrand.NoBrand && <>{children}</>}
    </Button>
  );
};
